import { useNavigate } from "react-router-dom";
import Logout from "../services/Logout";
import useAuth from "./useAuth";
import Cookies from 'universal-cookie';
import {cookie_domain_url} from "../configuration/apiURLConfigs";

const useLogout = () => {
  const navigate=useNavigate();
  const { setAuth } = useAuth();
  const cookies = new Cookies();

  const logout = async () => {

    const res = await Logout();
    if (res) {
      setAuth({
        accessToken: "",
        isLoggedIn: false,
      });
      localStorage.removeItem("userData");
      cookies.remove('ulid_D_P', { domain: cookie_domain_url });
      navigate("/");
    }
    return res;
  };
  return logout;
};
export default useLogout;